import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MeasurementsService } from './measurements.service';

@NgModule({
  imports: [ CommonModule ],
  providers: [ MeasurementsService ]
})
export class MeasurementsMisoModule {

}
